import React from 'react';
import methodModel from '../../../methods/methods';
import ImageUpload from '../../../components/common/ImageUpload';
import Layout from '../../../components/global/layout';
import rolesModel from '../../../models/roles.model';
import SelectDropdown from '../../../components/common/SelectDropdown';
import PhoneInput from 'react-phone-input-2';
import { Tooltip } from 'antd';
import { rolePermission, rolePermissions } from '../../../models/type.model';

const Html = ({
  role,
  id,
  form,
  handleSubmit,
  setform,
  roles,
  addressResult,
  submitted,
  images,
  imageResult,
  getError,
  setEyes,
  eyes,
  back,
  emailCheck,
  emailErr,
  emailLoader,
  detail,
}) => {
  const permissions = rolePermissions;
  const permission = rolePermission;
  const isAllChecked = () => {
    let value = true;
    let permissions = {
      user_add: form?.permissions?.user_add,
      user_delete: form?.permissions?.user_delete,  
      user_edit: form?.permissions?.user_edit,
      user_get: form?.permissions?.user_get,
      category_get: form?.permissions?.category_get,
      category_delete: form?.permissions?.category_delete,
      category_edit: form?.permissions?.category_edit,
      category_add: form?.permissions?.category_add,
      category_complete_access: form?.permissions?.category_complete_access,
      blog_get: form?.permissions?.blog_get,
      blog_delete: form?.permissions?.blog_delete,
      blog_edit: form?.permissions?.blog_edit,
      blog_add: form?.permissions?.blog_add,
      blog_complete_access: form?.permissions?.blog_complete_access,
      course_get: form?.permissions?.course_get,
      course_delete: form?.permissions?.course_delete,
      course_edit: form?.permissions?.course_edit,
      course_add: form?.permissions?.course_add,
      course_complete_access: form?.permissions?.course_complete_access,
    };
    Object.keys(permissions).map((itm) => {
      if (!permissions[itm]) value = false;
    });
    return value;
  };
  console.log(form);


  const HandleAll = (check) => {
    let value = check ? true : false;
    let permissions = {
      user_add: form?.permissions?.user_add,
      user_delete: form?.permissions?.user_delete,
      user_edit: form?.permissions?.user_edit,
      user_get: form?.permissions?.user_get,
      user_complete_access: form?.permissions?.user_complete_access,
      category_get: form?.permissions?.category_get,
      category_delete: form?.permissions?.category_delete,
      category_edit: form?.permissions?.category_edit,
      category_add: form?.permissions?.category_add,
      category_complete_access: form?.permissions?.category_complete_access,
      blog_get: form?.permissions?.blog_get,
      blog_delete: form?.permissions?.blog_delete,
      blog_edit: form?.permissions?.blog_edit,
      blog_add: form?.permissions?.blog_add,
      blog_complete_access: form?.permissions?.blog_complete_access,
      course_get: form?.permissions?.course_get,
      course_delete: form?.permissions?.course_delete,
      course_edit: form?.permissions?.course_edit,
      course_add: form?.permissions?.course_add,
      course_complete_access: form?.permissions?.course_complete_access,
    };
    console.log(Object?.keys(permissions).map((itm)=>{itm}),'lljsss')
    Object?.keys(permissions).map((itm) => {
      permissions[itm] = value;
    });

    setform({ ...form, permissions: permissions });
  };

  const isCheckAll = (key) => {
    let value = true;
    permission.map((itm) => {
      if (!form?.permissions[`${itm.key}${key}`]) value = false;
    });
    return value;
  };
  const handleAdminUser = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        user_get: value,
        user_delete: value,
        user_edit: value,
        user_add: value,
        user_complete_access: value,
      },
    });
    // setpermission('carrier_complete_access',value)
  };
  const handleAdminCategory = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        category_get: value,
        category_delete: value,
        category_edit: value,
        category_add: value,
        category_complete_access: value,
      },
    });
    // setpermission('carrier_complete_access',value)
  };
  const handleAdminBLog = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        blog_get: value,
        blog_delete: value,
        blog_edit: value,
        blog_add: value,
        blog_complete_access: value,
      },
    });
    // setpermission('carrier_complete_access',value)
  };
  const handleAdminCourse = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        course_get: value,
        course_delete: value,
        course_edit: value,
        course_add: value,
        course_complete_access: value,
      },
    });
    // setpermission('carrier_complete_access',value)
  };

  const setpermission = (key, value) => {
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        [key]: value,
      },
    });
  };

  const isAllPCheck = (key = 'read') => {
    let value = true;
    permissions?.map((itm) => {
      if (!form.permissions[`${key}${itm.key}`]) value = false;
    });
    return value;
  };

  const handleAllPermission = (e) => {
    let key = e.name;
    let checked = e.checked;

    let keys = {};
    permission?.map((itm) => {
      keys = { ...keys, [`${itm.key}_${key}`]: checked };
    });

    setform({
      ...form,
      permissions: {
        ...form?.permissions,
        ...keys,
      },
    });
  };

  const handlecompleteAccess = () => {
    let result = false;
    if (
      form?.permissions?.user_add &&
      form?.permissions?.user_edit &&
      form?.permissions?.user_delete &&
      form?.permissions?.user_get &&
      form?.permissions?.user_complete_access
    ) {
      result = true;
    }
    // setform({...form,permissions:{...form?.permissions,carrier_complete_access:result}})
    return result;
  };
  const handlecompleteAccessCategory = () => {
    let result = false;
    if (
      form?.permissions?.category_get &&
      form?.permissions?.category_edit &&
      form?.permissions?.category_delete &&
      form?.permissions?.category_get &&
      form?.permissions?.category_complete_access
    ) {
      result = true;
    }
    // setform({...form,permissions:{...form?.permissions,carrier_complete_access:result}})
    return result;
  };
  const handlecompleteAccessBlog = () => {
    let result = false;
    if (
      form?.permissions?.blog_get &&
      form?.permissions?.blog_edit &&
      form?.permissions?.blog_delete &&
      form?.permissions?.blog_get &&
      form?.permissions?.blog_complete_access
    ) {
      result = true;
    }
    // setform({...form,permissions:{...form?.permissions,carrier_complete_access:result}})
    return result;
  };
  const handlecompleteAccessCourse = () => {
    let result = false;
    if (
      form?.permissions?.course_get &&
      form?.permissions?.course_edit &&
      form?.permissions?.course_delete &&
      form?.permissions?.course_get &&
      form?.permissions?.course_complete_access
    ) {
      result = true;
    }
    // setform({...form,permissions:{...form?.permissions,carrier_complete_access:result}})
    return result;
  };
  const arry = [
    1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991,
    1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003,
    2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015,
    2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
  ];
  const HandleAllRead = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        user_get: value,
        category_get: value,
        blog_get: value,
        course_get: value,
      },
    });
    isAllChecked();
  };
  const HandleAllAdd = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        user_add: value,
        category_add: value,
        blog_add: value,
        course_add: value,
      },
    });
    isAllChecked();
  };
  const HandleallEdit = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        user_edit: value,
        category_edit: value,
        blog_edit: value,
        course_edit: value,
      },
    });
    isAllChecked();
  };
  const HandleAllDelete = (check) => {
    let value = check ? true : false;
    setform({
      ...form,
      permissions: {
        ...form.permissions,
        user_delete: value,
        category_delete: value,
        blog_delete: value,
        course_delete: value,
      },
    });
    isAllChecked();
  };

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit} autoComplete="false" name="addSubAdmin">
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all    mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? 'Edit' : 'Add'}{' '}
                  {role ? rolesModel.name(role) : 'Sub Admin'}
                </h3>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6">
                <label>
                  First Name<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form?.firstName}
                  onChange={(e) => {
                    const fetchdata = e.target.value;
                    const inputdata = fetchdata.replace(/[^A-Za-z]/ig, '')

                    setform({ ...form, firstName: inputdata })
                  }}
                />
                {submitted && !form.firstName ? (
                  <div className="invalid-feedback d-block">
                    First Name is Required
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="col-span-12 md:col-span-6">
                <label>
                  Last Name<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  value={form?.lastName}
                  onChange={(e) => {
                    const fetchlastdata = e.target.value;
                    const inputLastNameData = fetchlastdata.replace(/[^A-Za-z']/ig, '')
                    setform({ ...form, lastName: inputLastNameData })
                  }}
                />
                {submitted && !form?.lastName ? (
                  <div className="invalid-feedback d-block">
                    Last Name is Required
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Gender
                </label>
                <SelectDropdown
                  id="statusDropdown"
                  displayValue="name"
                  placeholder="Select Gender"
                  intialValue={form?.gender}
                  country="1"
                  disabled={form?.id && form?.gender != ""}
                  result={(e) => {
                    setform({ ...form, gender: e.value });
                  }}
                  options={[
                    { id: 'male', name: 'Male' },
                    { id: 'female', name: 'Female' },
                    { id: 'others', name: 'Other' },
                  ]}
                />
                {/* {submitted && !form?.gender ? (
                  <div className="invalid-feedback d-block">
                    Gender is Required
                  </div>
                ) : (
                  <></>
                )} */}
              </div>

              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Mobile No.<span className="star">*</span>
                </label>
                <div className="mobile_number">
                  <PhoneInput
                    value={form.dialCode + '' + form.mobileNo}
                    country={'us'}
                    enableSearch={true}
                    limitMaxLength
                    required
                    onChange={(e, a) => {
                      let phonenumber = e.replace(a.dialCode, '');
                      setform({
                        ...form,
                        mobileNo: phonenumber,
                        dialCode: a?.dialCode,
                      });
                    }}
                    countryCodeEditable={true}
                  />
                </div>
                {/* {submitted && getError('dialCode').invalid ? (
                  <div className="invalid-feedback d-block">
                    invalid country code
                  </div>
                ) : (
                  <></>
                )} */}
                {submitted && getError('mobileNo').invalid ? (
                  <div className="invalid-feedback d-block">
                    Min Length is 10
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Email<span className="star">*</span>
                </label>
                <input
                  type="email"
                  // pattern="/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  autoComplete="false"
                  value={form.email}
                  required
                  onChange={(e) => {
                    setform({ ...form, email: e.target.value });
                  }}
                  disabled={id}
                />
                {submitted && getError('email').invalid ? (
                  <div className="invalid-feedback d-block">
                    Email is Invalid
                  </div>
                ) : (
                  <></>
                )}
                {submitted && !form?.email ? (
                  <div className="invalid-feedback d-block">
                    Email is Required
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {/* <div className="col-span-12 md:col-span-6 ">
                <label>Password</label>
                <div className="inputWrapper">
                  <input
                    type={eyes.password ? 'text' : 'password'}
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form.password}
                    autoComplete="new-password"
                    onChange={(e) =>
                      setform({ ...form, password: e.target.value })
                    }
                  />
                  <i
                    className={
                      eyes.password
                        ? 'fa fa-eye text-gray-200 text-xs'
                        : 'fa fa-eye-slash text-gray-200 text-xs'
                    }
                    onClick={() =>
                      setEyes({ ...eyes, password: !eyes.password })
                    }
                  ></i>
                </div>
                {submitted && getError('password').invalid ? (
                  <div className="invalid-feedback d-block">
                    Password minimum length should be 8
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Confirm Password{' '}
                  {form.password ? <span className="star">*</span> : <></>}
                </label>
                <div className="inputWrapper">
                  <input
                    type={eyes.confirmPassword ? 'text' : 'password'}
                    className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                    value={form.confirmPassword}
                    onChange={(e) =>
                      setform({ ...form, confirmPassword: e.target.value })
                    }
                    required={form.password ? true : false}
                  />
                  <i
                    className={
                      eyes.confirmPassword
                        ? 'fa fa-eye text-gray-200 text-xs'
                        : 'fa fa-eye-slash text-gray-200 text-xs'
                    }
                    onClick={() =>
                      setEyes({
                        ...eyes,
                        confirmPassword: !eyes.confirmPassword,
                      })
                    }
                  ></i>
                </div>
                {submitted && getError('confirmPassword').invalid ? (
                  <div className="invalid-feedback d-block">
                    Confirm Password is not matched with Password
                  </div>
                ) : (
                  <></>
                )}
              </div> */}
              <div className="col-span-12 md:col-span-12 mb-3">
                <label className="lablefontcls">Image</label>
                <br></br>
                <ImageUpload
                  model="users"
                  result={(e) => imageResult(e, 'image')}
                  value={images.image || form?.image}
                  multiple={false}
                />
              </div>
            </div>
            {/* <div className="shadow-box w-full bg-white rounded-lg mb-6">
              <div className="scrollbar w-full overflow-auto">
                <div class="table_section tablepadding">
                  <p className="text-xl font-semibold text-[#111827] px-4 pb-2">
                    Permissions
                  </p>
                  <table class="w-full">
                    <thead class="table_head roleTable">
                      <tr class="border-b border-[#EAECF0]">
                        <th
                          scope="col"
                          class="cursor-pointer text-[#82838B] !border-l-0 font-normal text-sm !border border-[#EAECF0] !px-5 text-left bg-[#F7FAFF] !py-3 ' onClick={e => sorting('name')}"
                        ></th>
                        <th
                          scope="col"
                          class="cursor-pointer text-[#82838B] !border-l-0 font-normal text-sm !border border-[#EAECF0] !px-5 text-left bg-[#F7FAFF] !py-3 ' onClick={e => sorting('name')}"
                        >
                          <input
                            type="checkbox"
                            className="h-4 w-4 green_check cursor-pointer shrink-0 rounded-[4px] !border !border-[#3C3E49A3] !text-white"
                            onChange={(e) => HandleAll(e.target.checked)}
                            checked={isAllChecked()}
                          />
                          All
                        </th>
                        {permission.map((itm) => {
                          return (
                            <>
                              <th
                                scope="col"
                                class="cursor-pointer text-[#82838B] !border-l-0 font-normal text-sm !border border-[#EAECF0] !px-5 text-left bg-[#F7FAFF] !py-3 ' onClick={e => sorting('name')}"
                              >
                                <input
                                  type="checkbox"
                                  className="h-4 w-4 green_check cursor-pointer shrink-0 rounded-[4px] !border !border-[#3C3E49A3] !text-white"
                                  onChange={(e) =>
                                    HandleAllRead(e.target.checked, itm.key)
                                  }
                                  checked={isAllPCheck(itm.key)}
                                />
                                {itm.name}
                              </th>
                            </>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody className="roleTable">
                      {permissions.map((itm) => {
                        return (
                          <>
                            <tr>
                              <td className="!text-typo !border-l-0 cursor-pointer !px-5 text-sm font-normal !py-2 !border text-left border-[#EAECF0]">
                                {itm.name}
                              </td>
                              <td className="!text-typo !border-l-0 cursor-pointer !px-5 text-sm font-normal !py-2 !border text-left border-[#EAECF0]">
                                <input
                                  type="checkbox"
                                  className="h-4 w-4 green_check cursor-pointer shrink-0 rounded-[4px] !border !border-[#3C3E49A3] !text-white"
                                  name={itm.key}
                                  onChange={(e) =>
                                    handleAllPermission(e.target)
                                  }
                                  checked={isCheckAll(itm.key)}
                                />
                              </td>
                              {permission.map((pitm) => {
                                return (
                                  <td className="!text-typo !border-l-0 cursor-pointer !px-5 text-sm font-normal !py-2 !border text-left border-[#EAECF0]">
                                    <div Name="checkList">
                                      <label className="mb-0">
                                        <input
                                          type="checkbox"
                                          className="h-4 w-4 green_check cursor-pointer shrink-0 rounded-[4px] !border !border-[#3C3E49A3] !text-white"
                                          checked={
                                            form.permissions[
                                              `${itm.key}${pitm.key}_`
                                            ]
                                          }
                                          onChange={(e) =>
                                            setpermission(
                                              `${itm.key}${pitm.key}_`,
                                              e.target.checked
                                            )
                                          }
                                        />
                                      </label>
                                    </div>
                                  </td>
                                );
                              })}
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div> */}

            <div className="border_div border-b-[1px] border-dashed border-[#A12238] mt-5 mb-5"></div>

            <div className="col-md-12 mb-3">
              <h5 className="text-[#A12238] mb-2">
                <b>Permissions</b>
              </h5>

              <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase dark:text-gray-400">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                      ></th>
                      <th scope="col" className="px-6 py-3">
                        <span className="flex items-center">
                          <input
                            type="checkbox"
                            onChange={(e) => HandleAll(e.target.checked)}
                            checked={isAllChecked()}
                          />
                          All
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                      >
                        <span className="flex items-center">
                          <input
                            type="checkbox"
                            onChange={(e) => HandleAllRead(e.target.checked)}
                            checked={
                              form?.permissions?.user_get &&
                              form?.permissions?.category_get &&
                              form?.permissions?.blog_get &&
                              form?.permissions?.course_get
                            }
                          />
                          Read
                        </span>
                      </th>
                      <th scope="col" className="px-6 py-3">
                        <span className="flex items-center">
                          {' '}
                          <input
                            type="checkbox"
                            onChange={(e) => HandleAllAdd(e.target.checked)}
                            checked={
                              form?.permissions?.user_add &&
                              form?.permissions?.category_add &&
                              form?.permissions?.blog_add &&
                              form?.permissions?.course_add
                            }
                          />
                          Add
                        </span>
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 bg-gray-50 dark:bg-gray-800"
                      >
                        <span className="flex items-center">
                          {' '}
                          <input
                            type="checkbox"
                            onChange={(e) => HandleallEdit(e.target.checked)}
                            checked={
                              form?.permissions?.user_edit &&
                              form?.permissions?.category_edit &&
                              form?.permissions?.blog_edit &&
                              form?.permissions?.course_edit
                            }
                          />
                          Edit
                        </span>
                      </th>
                      <th scope="col" className="px-6 py-3">
                        <span className="flex items-center">
                          {' '}
                          <input
                            type="checkbox"
                            onChange={(e) => HandleAllDelete(e.target.checked)}
                            checked={
                              form?.permissions?.user_delete &&
                              form?.permissions?.category_delete &&
                              form?.permissions?.blog_delete &&
                              form?.permissions?.course_delete
                            }
                          />
                          Delete
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-gray-200 dark:border-gray-700">
                      <th
                        scope="row"
                        class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                      >
                        Users
                      </th>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              handleAdminUser(e.target.checked);
                              //   if(e.target?.checked){
                              //     setform({...form,permissions:{...form?.permissions,carrier_complete_access:true}})
                              //   }else
                            }}
                            checked={handlecompleteAccess()}
                          />
                        </span>
                      </td>
                      <td className="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.user_get}
                            onChange={(e) =>
                              setpermission('user_get', e.target.checked)
                            }
                          />
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.user_add}
                            onChange={(e) =>
                              setpermission('user_add', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                      <td className="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.user_edit}
                            onChange={(e) =>
                              setpermission('user_edit', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.user_delete}
                            onChange={(e) =>
                              setpermission('user_delete', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 dark:border-gray-700">
                      <th
                        scope="row"
                        class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                      >
                        Category
                      </th>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              handleAdminCategory(e.target.checked);
                              //   if(e.target?.checked){
                              //     setform({...form,permissions:{...form?.permissions,carrier_complete_access:true}})
                              //   }else
                            }}
                            checked={handlecompleteAccessCategory()}
                          />
                        </span>
                      </td>
                      <td className="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.category_get}
                            onChange={(e) =>
                              setpermission('category_get', e.target.checked)
                            }
                          />
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.category_add}
                            onChange={(e) =>
                              setpermission('category_add', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                      <td className="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.category_edit}
                            onChange={(e) =>
                              setpermission('category_edit', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.category_delete}
                            onChange={(e) =>
                              setpermission('category_delete', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 dark:border-gray-700">
                      <th
                        scope="row"
                        class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                      >
                        Blogs
                      </th>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              handleAdminBLog(e.target.checked);
                              //   if(e.target?.checked){
                              //     setform({...form,permissions:{...form?.permissions,carrier_complete_access:true}})
                              //   }else
                            }}
                            checked={handlecompleteAccessBlog()}
                          />
                        </span>
                      </td>
                      <td className="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.blog_get}
                            onChange={(e) =>
                              setpermission('blog_get', e.target.checked)
                            }
                          />
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.blog_add}
                            onChange={(e) =>
                              setpermission('blog_add', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                      <td className="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.blog_edit}
                            onChange={(e) =>
                              setpermission('blog_edit', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.blog_delete}
                            onChange={(e) =>
                              setpermission('blog_delete', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                    </tr>
                    <tr className="border-b border-gray-200 dark:border-gray-700">
                      <th
                        scope="row"
                        class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap bg-gray-50 dark:text-white dark:bg-gray-800"
                      >
                        Course
                      </th>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              handleAdminCourse(e.target.checked);
                              //   if(e.target?.checked){
                              //     setform({...form,permissions:{...form?.permissions,carrier_complete_access:true}})
                              //   }else
                            }}
                            checked={handlecompleteAccessCourse()}
                          />
                        </span>
                      </td>
                      <td className="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.course_get}
                            onChange={(e) =>
                              setpermission('course_get', e.target.checked)
                            }
                          />
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.course_add}
                            onChange={(e) =>
                              setpermission('course_add', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                      <td className="px-6 py-4 bg-gray-50 dark:bg-gray-800">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.course_edit}
                            onChange={(e) =>
                              setpermission('course_edit', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="">
                          <input
                            type="checkbox"
                            checked={form?.permissions?.course_delete}
                            onChange={(e) =>
                              setpermission('course_delete', e.target.checked)
                            }
                          />{' '}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default Html;
